import { CommentItem } from "pages/api/discuss/debate/[discussId]";
import { useDebateContext } from "contexts/DebateContext";
import DebateSetting from "./Setting";
import { useCallback, useRef } from "react";
import { DiscussDetailDebateSkeleton } from "components/skeleton/discuss";
import OpinionInput from "./OpinionInput";
import EmptyOpinion from "./EmptyOpinion";
import MainOpinionTemplete from "./MainOpinionTemplete";

function OpinionListIndex({
  isMobile,
  issueAt,
}: {
  isMobile: boolean;
  issueAt?: string;
}) {
  const {
    opinionList,
    isCommentDisabled,
    loadMore,
    isLoadingMore,
    isReachingEnd,
    isClosed,
  } = useDebateContext();
  const observerRef = useRef<IntersectionObserver | null>(null);
  const observeLastItem = useCallback(
    (node: HTMLDivElement | null) => {
      if (isLoadingMore || isReachingEnd) return;
      if (observerRef?.current) observerRef.current.disconnect();

      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          loadMore(); // 마지막 요소가 보이면 loadMore 실행
        }
      });

      if (node) observerRef.current.observe(node);
    },
    [isLoadingMore, isReachingEnd, loadMore]
  );

  return (
    <div className="flex flex-col gap-4 bg-white">
      {!isCommentDisabled && <OpinionInput isMobile={isMobile} />}

      <div className="flex flex-col gap-2 pb-[150px]">
        <DebateSetting />
        {opinionList?.length > 0 && (
          <div className="flex flex-col gap-3 bg-white ">
            <div className="flex flex-col gap-3 bg-white">
              {opinionList?.map((option: CommentItem, index: number) => (
                <div className="px-4 " key={index}>
                  <MainOpinionTemplete key={index} data={option} />
                </div>
              ))}
              <div ref={observeLastItem} className="h-1" />
              {isLoadingMore && <DiscussDetailDebateSkeleton />}
            </div>
          </div>
        )}
        <div className="flex flex-col  bg-white ">
          {opinionList?.length === 0 && <EmptyOpinion />}
        </div>
      </div>
    </div>
  );
}

export default OpinionListIndex;
